export default {
    SELECT: (state, payload) => {
        state[payload.key] = payload.value;
    },
    LAUNCH_RESEARCH: (state, payload) => {
        state.launch_research = payload.launch;
    },
    LAUNCH_DETAIL_RESEARCH: (state, payload) => {
        state.launch_detail_research = payload.launch_detail_research;
    },
    RESET_STATE: (state) => {
        state.detail_fref = '';
        state.detail_fmod = '';
        state.detail_fcol = '';
        state.detail_ftail = '';
    },
    RESET_RESEARCH: (state) => {
        
        state.fref = '',
        state.fmod = '',
        state.fcol = '',
        state.fdate_cdemin = '',
        state.fdate_cdemax = '',
        state.fstatut = '100',
        state.fncde = ''
    }
};